Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.InterpolationMethod = module.exports.default = {
	LINEAR_RGB: "linearRGB",
	RGB: "rgb"
};